export default __webpack_public_path__ + "static/media/no-result.9d1e2fe4.svg";